/**
 * 作品详情顶级组件
 * @author wangyichen
 * @since 2018/08/16
 */

import './app-detail.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// import Stat from '@fe/common/lib/stat';
// import { sendStat } from 'utils/common';

import H5 from './h5';
import Thumbnail from './thumbnail';
import BaseInfo from './base-info';
import RecommonList from 'containers/app-detail/recommon-list';
import Banner from 'components/app-detail/banner';
class AppDetail extends Component {
  static propTypes = {
    // 基础信息
    baseInfo: PropTypes.object,
    // banner图
    banner: PropTypes.array,
  };

  constructor() {
    super();
    this.state = {
      // 当前页码
      currentPage: 1,
      // 目标页码
      targetPage: 0,
      // 页面总数
      pageCount: 0,
      // 是否允许循环翻页
      pageLoop: false,
    };
  }
  // 设置是否允许循环翻页
  setPageLoop = pageLoop => {
    this.setState({
      pageLoop,
    });
  };
  // 目标页的状态提升
  setTargetPage = targetPage => {
    this.setState({
      targetPage,
    });
  };
  // 当前页的状态提升
  setCurrentPage = currentPage => {
    this.setState({
      currentPage,
    });
  };
  // 设置pageCount
  setPageCount = pageCount => {
    this.setState({
      pageCount,
    });
  };
  render() {
    const { targetPage, currentPage, pageCount, pageLoop } = this.state;
    const { banner, baseInfo } = this.props;
    return (
      <div className="wrapper">
        <div className="show-block">
          <H5
            targetPage={targetPage}
            pageCount={pageCount}
            baseInfo={baseInfo}
            pageLoop={pageLoop}
            setCurrentPage={this.setCurrentPage}
          />
          <Thumbnail
            pageCount={pageCount}
            currentPage={currentPage}
            setPageLoop={this.setPageLoop}
            setTargetPage={this.setTargetPage}
            setPageCount={this.setPageCount}
            {...this.props}
          />
        </div>
        <BaseInfo baseInfo={baseInfo} />
        <RecommonList />
        <Banner banner={banner} />
      </div>
    );
  }
}

export default AppDetail;
